export default __webpack_public_path__ + "assets/nav-logo-component.71944b2e.svg";